import { AccessorKeyColumnDefBase } from "@tanstack/react-table";
import { Table, TableProps } from "src/components/table";

type OrderInvoicingTableProps<T> = TableProps<T> & {
    configColumns?: string[];
};

export function OrderInvoicingTable<T>({
    configColumns = [],
    columns,
    ...props
}: OrderInvoicingTableProps<T>) {
    const filteredColumns = columns.filter((column) => {
        const accessorKey =
            column.id || (column as AccessorKeyColumnDefBase<T>)?.accessorKey;

        const accessorKeyString = String(accessorKey);

        return configColumns.includes(accessorKeyString);
    });

    return (
        <Table
            columns={filteredColumns}
            columnOrder={configColumns}
            {...props}
        />
    );
}
